import { render, staticRenderFns } from "./CallDeleteComment.vue?vue&type=template&id=64baabe4"
import script from "./CallDeleteComment.vue?vue&type=script&lang=js"
export * from "./CallDeleteComment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports